export const SERVICE_CODE = 'CONTRACTS_SERVICE';
